import { render, staticRenderFns } from "./DeletePatient.vue?vue&type=template&id=5a8a9ba8&scoped=true&"
import script from "./DeletePatient.vue?vue&type=script&lang=ts&"
export * from "./DeletePatient.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePatient.vue?vue&type=style&index=0&id=5a8a9ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a9ba8",
  null
  
)

export default component.exports